// Single source of truth for brand, entity, and contact details (D-010).
//
// Baked in as plain values (no env vars). These are all PUBLIC details shown
// on the site. Empty values hide themselves in the UI so we never render a
// placeholder line (D-004); the `has()` helper below supports that.

export const legal = {
  // Brand + entity.
  brandName: "Migration & More",
  tagline: "Migration support, matched with a registered migration agent",

  // We are not a registered migration agent (D-009), so there is no MARN of
  // ours. If a matched agent's MARN is ever shown on a page it is theirs; set
  // it here (or per agent) then. Blank = nothing renders.
  marn: "",

  // Registered legal entity (used on the legal pages and invoices).
  legalEntityName: "Migration & More Pty Ltd",
  abn: "", // hides itself until supplied

  // Contact.
  phone: "0468 227 946",
  email: "info@migrationandmore.com",

  // Primary office.
  office: {
    line1: "17 Caryota Ct",
    line2: "",
    city: "Tamborine Mountain",
    state: "QLD",
    postcode: "4272",
    country: "Australia",
  },

  hours: "Mon to Fri, 9am to 5pm",

  // Production site origin (canonical URLs, sitemap). Confirm www vs apex.
  siteUrl: "https://migrationandmore.com",

  // Client portal. Separate app, separate host, so this is an absolute URL and
  // not a React Router route.
  portalUrl: "https://app.migrationandmore.com",

  // Social links (footer). Empty = icon hidden.
  social: {
    facebook: "",
    instagram: "",
    linkedin: "",
    youtube: "",
  },
};

// True when a value is real (not empty). Use to hide unknown lines (D-004).
export const has = (v) => typeof v === "string" && v.trim().length > 0;

// Formatted single-line address from whatever office fields are present.
// Australian style: suburb, state, and postcode sit together without commas
// (e.g. "17 Caryota Ct, Tamborine Mountain QLD 4272, Australia").
export const officeOneLine = () => {
  const o = legal.office;
  const locality = [o.city, o.state, o.postcode].filter(has).join(" ");
  return [o.line1, o.line2, locality, o.country].filter(has).join(", ");
};

// The registered legal entity name for legal copy, falling back to the brand
// name if the entity is ever blanked.
export const entityName = () =>
  has(legal.legalEntityName) ? legal.legalEntityName : legal.brandName;

// Standing compliance disclaimer (D-003). Use wherever outcomes are discussed.
export const OUTCOME_DISCLAIMER =
  "Visa decisions are made solely by the Department of Home Affairs. No outcome is guaranteed. Eligibility depends on your individual circumstances.";

// The three-party split, for the shared "how this works" bands. Keep our own
// verbs strong and active; only advice and lodgement belong to the agent.
export const WHO_DOES_WHAT = {
  heading: "How this works",
  us: "We get your documents application-ready, match you with a registered migration agent we have vetted, and stay on the matter until it is lodged.",
  agent: "A registered migration agent gives the migration advice and lodges your application.",
  dept: "The Department of Home Affairs decides. No outcome is guaranteed.",
};

export default legal;
